/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

const browserUpdate = require('browser-update')
exports.onClientEntry = () => {
	browserUpdate({
		required: { e: 16, f: -2, o: -2, s: -1, c: -2 },
		insecure: true,
		unsupported: true,
		api: 2018.11,
		// test: true,
	})
	const isIE11 = !!window.MSInputMethodContext && !!document.documentMode
	console.log('Browser out of date:', isIE11)
}
